import {
  decodeJwt as decodeJwtShared,
  getJwtDisplayName,
  getJwtRole,
  getJwtUserId,
  isJwtExpired,
  willJwtExpireSoon,
} from "@horseed/shared/auth";
const TOKEN_KEY = "auth_token";
const USERNAME_KEY = "auth_username"; // legacy (username or email)
const CLAIMS_KEY = "auth_claims"; // JSON of decoded claims
export const decodeJwt = decodeJwtShared;
export const getToken = () => {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(TOKEN_KEY);
};
export const getUsername = () => {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(USERNAME_KEY);
};
export const loginPersist = (token, username) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(TOKEN_KEY, token);
  if (username) localStorage.setItem(USERNAME_KEY, username);
  const claims = decodeJwt(token) || {};
  try {
    localStorage.setItem(CLAIMS_KEY, JSON.stringify(claims));
  } catch (_) {
    // ignore storage errors
  }
};
export const logout = () => {
  if (typeof window === "undefined") return;
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USERNAME_KEY);
  localStorage.removeItem(CLAIMS_KEY);
};
export const isAuthenticated = () => !!getToken();
export const getClaims = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(CLAIMS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
};
export const getUserId = () => getJwtUserId(getClaims());
export const getUserRole = () => getJwtRole(getClaims());
// Preferred display name: Name -> name -> sub (email/username) -> legacy stored username
export const getUserName = () => getJwtDisplayName(getClaims(), getUsername());
export const isTokenExpired = () => isJwtExpired(getClaims());
export const willExpireSoon = (thresholdSeconds = 300) =>
  willJwtExpireSoon(getClaims(), thresholdSeconds);